module.exports = __webpack_public_path__ + "static/media/jquery.90390bd7.svg";